import { render, staticRenderFns } from "./PositionMarketPrice.vue?vue&type=template&id=ea33c27e&"
import script from "./PositionMarketPrice.vue?vue&type=script&lang=js&"
export * from "./PositionMarketPrice.vue?vue&type=script&lang=js&"
import style0 from "./PositionMarketPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VTooltip})
